import CarouselSection from './carouselSection/CarouselSection';
import ContactUsBtn from './contactus/ContactUsBtn';
import Header from './header/Header';
import OurServices from './services/OurServices';

function App() {
  return (
    <div>
      <Header/>
      <CarouselSection/>
      <OurServices/>
      <ContactUsBtn/>
    </div>
  );
}

export default App;
